module.exports = __webpack_public_path__ + "static/media/female-right-2.a1265104.png";